import React from 'react'
import type { AutomationTarget } from '../../../types'
import Text from '../text'
import { formatters } from '../../../utils'
import InfoPill, { InfoPillProps } from '../infoPill'

export type TextSize =
  | 'mini'
  | 'tiny'
  | 'small'
  | 'large'
  | 'big'
  | 'huge'
  | 'massive'

export type TextWeight = 'normal' | 'medium' | 'heavy' | 'black'
interface MoneyProps extends AutomationTarget {
  amount: string | number
  size?: TextSize
  weight?: TextWeight
  className?: string
  color?: string
  overrides?: Intl.NumberFormatOptions
  infoPill?: InfoPillProps
  hideDecimals?: boolean
}

const Money: React.FunctionComponent<MoneyProps> = ({
  amount,
  size,
  weight,
  className,
  color,
  overrides,
  elmId = 'money',
  infoPill = undefined,
  hideDecimals = false,
}) => (
  <>
    {infoPill ? (
      <InfoPill
        size={infoPill.size}
        backgroundColor={infoPill.backgroundColor}
        foregroundColor={infoPill.foregroundColor}
        includeBorder={infoPill.includeBorder}
        iconName={infoPill.iconName}
        iconColor={infoPill.iconColor}
        iconOnRight={infoPill.iconOnRight}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        content={formatters.formatMoney(amount, overrides, hideDecimals, '$0')}
        fontWeight={infoPill.fontWeight}
        label={infoPill.label}
        extraPadding={infoPill.extraPadding}
        style={infoPill.style}
        elmId={`${infoPill.elmId || elmId || ''}`}
      />
    ) : (
      <Text
        elmId={elmId}
        size={size}
        weight={weight}
        className={className}
        color={color}
      >
        {formatters.formatMoney(amount, overrides, hideDecimals, '$0')}
      </Text>
    )}
  </>
)

export default Money
